import {
  BaseActionObject,
  DoneInvokeEvent,
  StateNodeConfig,
  assign
} from "xstate4"
import { Context, Transitions } from "../../../../types"
import { getServiceErrorMessage } from "../../../../helpers"

export const togglePublishedPlanBreakAfterSectionTransition: StateNodeConfig<
  Context,
  {},
  Transitions,
  BaseActionObject
> = {
  invoke: {
    src: "togglePublishedPlanBreakAfterSection",
    onDone: {
      target: "#StudyPlan.get_current_plan"
    },
    onError: {
      target: "idle",
      actions: assign<Context, DoneInvokeEvent<any>>({
        snackbar: (_ctx, _evt) => ({
          message: getServiceErrorMessage("toggleBreakAfterSection", {
            messageData: ["toggle break after section"]
          }),
          withUndo: false,
          error: true
        })
      })
    }
  }
}
